import React, {useState, useEffect} from "react";
import "../components/Blog.css";
import { useLocation } from "react-router-dom";

const BlogDetails = () => {
  const location = useLocation();

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                Getting Started with FileZilla: A Comprehensive Guide to Secure File Transfers
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

               <h2>Introduction</h2>
                <p>
                  In today’s digital landscape, transferring files quickly and securely is a key part of many workflows—whether you're managing a website, sharing large documents, or backing up data. One of the most trusted tools for secure and efficient file transfer is FileZilla. This guide will walk you through everything you need to know to get started with FileZilla and make your file transfers both simple and safe.
                </p>

                <h2>What is FileZilla?</h2>
                <p>
                  FileZilla is a free, open-source FTP client designed to help users move files between their local systems and remote servers. It supports multiple protocols, including FTP, FTPS (FTP Secure), and SFTP (SSH File Transfer Protocol), making it a versatile tool for anyone needing to transfer files over the internet. With its easy-to-use interface and strong security features, FileZilla is suitable for both beginners and experienced developers.
                </p>

                <h2>Why Choose FileZilla?</h2>
        
                <p>
                  FileZilla is a favorite among users for several reasons:
                </p>
        
        <ol>
          <li>Completely Free: No subscription or license required.</li>
          <li>Cross-Platform Support: Works on Windows, macOS, and Linux.</li>
          <li>Secure Protocols:Supports FTPS and SFTP for encrypted transfers.</li>
          <li>User-Friendly Interface:Drag-and-drop functionality simplifies the process.</li>
          <li>Site Manager: Save and manage multiple connection profiles.</li>
        </ol>
        <img src="graphics/images/filezilla1.webp" alt="Filezilla" />

                <h2>How to Download and Install FileZilla</h2>
                <p>
                 Getting FileZilla up and running is easy:
                </p>
        <ol>
          <li>Visit the official FileZilla website: https://filezilla-project.org</li>
          <li>Select the FileZilla Client (avoid the Server version unless you're setting up your own server).</li>
          <li>Choose the appropriate version for your operating system.</li>
          <li>Follow the on-screen installation instructions.</li>
        </ol>
        <p>Once installed, launch FileZilla to access its dual-pane interface—the left pane displays your local files, while the right shows remote server files once connected.</p>
        

                <h2>Connecting to a Server via FTP</h2>
                <p>
                  To make your first connection:
                </p>
        
        <ol>
          <li>Open FileZilla.</li>
          <li>In the Quickconnect bar, enter:
            <ol>
              <li>Host:The server address or IP</li>
              <li>Username & Password:Provided by your hosting provider.</li>
              <li>Port:Use 21 for FTP, or 22 for SFTP.</li>
            </ol>
          </li>
          <li>Click Quickconnect.</li>
        </ol>

                
                <p>
                  If the connection is successful, you’ll see the remote directory structure on the right-hand side. You can now begin transferring files between your local machine and the server.
                </p>

                <h2>Save Server Details with Site Manager</h2>
                <p>
                  For repeat connections, the Site Manager feature can save you time:
                </p>
        
        <ol>
          <li>Navigate to File > Site Manager.</li>
          <li>Click New Site and assign a name.</li>
          <li>Enter:
          <ol>
            <li>Host</li>
            <li>Port</li>
            <li>Protocol:FTP, FTPS, or SFTP.</li>
            <li>Login Type:Typically “Normal” for username/password access.</li>
          </ol>
          </li>
          <li>Click Connect or OK to save the configuration.</li>
        </ol>
        
        <p>
                  This way, you don’t need to re-enter credentials every time you connect.
                </p>
        
        <h2>FTP, FTPS, and SFTP: Which One to Use?</h2>
        
        <p>Understanding the differences in protocols is essential for safe transfers:</p>
        
        <ol>
          <li>FTP:The standard protocol, but it transmits data unencrypted.</li>
          <li>FTPS:Adds SSL/TLS encryption to FTP for better security.</li>
          <li>SFTP:Uses SSH to encrypt data; recommended for the most secure transfers.</li>
        </ol>
        
        <p>For sensitive data, always choose SFTP or FTPS over standard FTP.</p>
        
        
        <h2>File Transfer Best Practices</h2>
        
        <p>To get the most from FileZilla:</p>
        
        <ol>
          <li>Drag-and-Drop Transfers:Easily move multiple files or folders at once.</li>
          <li>Resume Support:Pause and resume transfers without losing progress.</li>
          <li>Detailed Logs:Monitor the connection and transfer progress in real-time.</li>
          <li>Overwrite Rules:Customize how duplicate files are handled—overwrite, rename, or skip.</li>
        </ol>
        
        <h2>Troubleshooting Common Issues</h2>
        
        <p>Encounter a problem? Here are some quick fixes:</p>
        
        <ol>
          <li>Connection Timeout:Check your internet connection or firewall settings.</li>
          <li>Login Failures:Ensure your credentials are correct</li>
          <li>Permission Denied:Contact your host to ensure you have the necessary write permissions.</li>
        </ol>
        
        <h2>Conclusion</h2>
        
        <p>FileZilla is a powerful and easy-to-use solution for secure file transfer using FTP, FTPS, or SFTP. Whether you're uploading website files, syncing directories, or sharing large data sets, FileZilla provides a reliable platform to get the job done safely. With its intuitive interface, support for encrypted protocols, and time-saving features like Site Manager, FileZilla makes transferring files over the internet both efficient and secure.</p>
        
        <p>Start using FileZilla today and take control of your file transfers like a pro.</p>
          </div>
        </div>

             {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
